import styled from 'styled-components';
import { device } from './responsives';

export const Container = styled.div`
  display: grid;
  margin: 0;
  width: 100vw;
  height: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: 75px 72px auto auto;
  background-color: #ffffff;
  padding: 0;

  @media ${device.maxlaptop}{
    grid-template-rows: 66px auto auto auto;
  }
  @media ${device.mobileM}{
    grid-template-columns: 100%;
  }
  `

export const Title= styled.h2`
  font-size: 40px;
  display: block;
  margin-bottom: 8px;
  margin-top: 0px;
  font-family: Avenir;
  font-weight: 900;
`

export const NavigationBar= styled.div`
  grid-column: 1 / span 3;
  display: block;
  height: auto;
  background-color: #e0e0e0;
  box-sizing: border-box;
  margin-top: 3px;
`

export const SearchSection= styled.div`
  margin-top: 20px;
  display: inline-block;
`

export const Content= styled.div`
  display: grid;
  grid-column: 1 / span 3;
  margin-left: 60px;
  margin-right: 60px;
  padding-bottom: 90px;
  border-radius: 5px;
  font-size: 150%;
  @media ${device.mobileL}{
    margin-left: 16px;
    margin-right: 16px;
  }
`

export const ProtoFlag= styled.h4`
  display: block;
  font-size: 18px;
  margin-bottom: 16px;
  margin-top: 0px;
  font-family: LucidaGrande;
  color: #4a4a4a;
`

export const Results= styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 3fr));
  grid-row-gap: 24px;
  grid-column-gap: 18px;
`

export const CardStyle= styled.div`
  grid-column-start: 1;
  grid-column-end: 3;
  @media ${device.maxlaptop}{
    max-width: 100wv;
    grid-column-start: 1;
    grid-column-end: 4;
  }

  @media ${device.mobileL}{
    grid-template-columns: 100%;
    grid-column-row: 260px 316px 316px;
  }
`

export const MapPlacement= styled.div`
  @media ${device.minlaptop}{
    grid-column-start: 3;
    grid-column-end: 4;
  }

  @media ${device.maxlaptop}{
    display: flex;
    flex-direction: row;
    grid-column: 1/span 3;
    width: 100%;
    max-width: 1024px;
  }
`

export const LowerTitle= styled.div`
  text-align: center;
  margin-top: 16px;
  @media ${device.maxlaptop}{
    display: none;
  }
`

export const ImgDisclaimer= styled.p`
  color: #4a4a4a;
  font-size: 12px;
  font-family: Avenir-Roman;

`
